import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
// import { Voucher } from "./voucher.model";
import { Voucher } from "./voucher.model";
import { Ledgerentries  } from "../../../master/ledger/shared/ledgerentries.model";

@Injectable({
  providedIn: 'root'
})

export class VoucherService {

  selectedVoucher: Voucher;
  VoucherList: Voucher[];

  selectedLedgerentries:Ledgerentries;
  LedgerentriesList: Ledgerentries[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {

    return environment.baseUrl;
  }

  IUDVoucher(voucher: Voucher) {

    voucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    voucher.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    voucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    voucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    voucher.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    voucher.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = voucher;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/voucher/IUD', body, { headers: headers });
  }

  GetVoucherTypeList() {
    
    this.selectedVoucher = new Voucher();
    this.selectedVoucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedVoucher.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedVoucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedVoucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/VoucherType', body, { headers: headers });
   }

  FetchVoucherById(voucher) {

    voucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    voucher.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    voucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    voucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = voucher;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/voucher/Fetch', body, { headers: headers });
  }

  FetchLedgerEntriesById(voucher) {

    // voucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    // voucher.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // voucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    // voucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    voucher.CostCentreId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    voucher.TransactionId = + voucher.Id
    voucher.FromDate = new Date(localStorage.getItem("FromDate"));
    voucher.ToDate = new Date(localStorage.getItem("ToDate")); 

    let body = voucher;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Accounts/FetchObjectList', body, { headers: headers });
  }


  //-----------------------------FetchVoucherList----Component-------------------------------------
  FetchVoucherList(ListByApprovalStatus: any) {

    this.selectedVoucher = new Voucher();
    this.selectedVoucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedVoucher.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedVoucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedVoucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    this.selectedVoucher.FromDate = new Date(localStorage.getItem("FromDate"));
    this.selectedVoucher.ToDate = new Date(localStorage.getItem("ToDate")); 
    this.selectedVoucher.ListByApprovalStatus = ListByApprovalStatus; // selecting sp
    
    let body = this.selectedVoucher;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/voucher/FetchList', body, { headers: headers });
  }

  FetchLedgerReports(rptSearchData: any) {

    this.selectedVoucher = new Voucher();
    if(rptSearchData.LedgerId != undefined) // calling from ledger report, so
    {
    this.selectedVoucher.Id = rptSearchData.LedgerId;
    }
    this.selectedVoucher.ReportName =rptSearchData.ReportName;
    this.selectedVoucher.ToDate =rptSearchData.LedgerToDate;    
    this.selectedVoucher.FromDate =rptSearchData.LedgerFromDate;
    this.selectedVoucher.EmployeeBranchId =rptSearchData.BranchId;

    this.selectedVoucher.CentreId =rptSearchData.CentreId; // daybook centrewise

    this.selectedVoucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedVoucher.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedVoucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedVoucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedVoucher;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Voucher/Report', body, { headers: headers });
  }

  FetchAutoLedgerById(voucherTypeId: any) {

    this.selectedLedgerentries = new Ledgerentries();
    this.selectedLedgerentries.VoucherTypeId =  + voucherTypeId;
    this.selectedLedgerentries.CostCentreId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedgerentries.FromDate = new Date(localStorage.getItem("FromDate"));
    this.selectedLedgerentries.ToDate = new Date(localStorage.getItem("ToDate"));  // to search date 

    // console.log(this.selectedLedgerentries);
    let body = this.selectedLedgerentries;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Accounts/FetchAutoLedger', body, { headers: headers });
  }
  
}

